import { cn } from "@/lib/utils";

const kind = (u: string) =>
  /\.(mp4|mov|webm)(\?|$)/i.test(u)
    ? "video"
    : /\.(mp3|m4a|wav|ogg)(\?|$)/i.test(u)
      ? "audio"
      : /\.(png|jpe?g|gif|webp|heic)(\?|$)/i.test(u)
        ? "image"
        : "file";

export function MessageBubble({ m }: { m: any }) {
  if (m.direction === "system") {
    return (
      <div className="text-center text-[11px] text-muted-foreground">
        {m.body}
      </div>
    );
  }
  const outgoing = m.direction === "outbound";
  return (
    <div className={cn("flex", outgoing ? "justify-end" : "justify-start")}>
      <div
        className={cn(
          "max-w-[80%] rounded-2xl px-3 py-2 text-sm",
          outgoing
            ? "rounded-br-sm bg-[#D96B27] text-white"
            : "rounded-bl-sm bg-muted text-foreground",
          m.status === "pending" && "opacity-60",
          m.status === "failed" && "border border-destructive",
        )}
      >
        <p className="whitespace-pre-wrap break-words">{m.body}</p>
        {(m.attachments ?? []).map((u: string, i: number) => (
          <Attachment key={i} url={u} />
        ))}
      </div>
    </div>
  );
}

function Attachment({ url }: { url: string }) {
  const k = kind(url);
  if (k === "image") {
    return (
      <img
        src={url}
        alt="Attachment"
        className="mt-1 max-h-40 w-full rounded object-cover"
      />
    );
  }
  if (k === "video") {
    return (
      <video src={url} controls className="mt-1 max-h-40 w-full rounded" />
    );
  }
  if (k === "audio") {
    return <audio src={url} controls className="mt-1 w-full" />;
  }
  return (
    <a
      href={url}
      target="_blank"
      rel="noreferrer"
      className="mt-1 block text-xs underline"
    >
      Open attachment
    </a>
  );
}
